<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert end -->
    <!-- Title-->
    <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />

    <!--Success Message popup -->
    <v-row justify="center">
      <v-dialog v-model="messagePopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-text class="text-center pt-12">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="redirectToIndex">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    
    <v-card-text class="pl-0 pr-0">
      <table style="width: 100%;" v-if="!user.roles.includes('area_service_manager')">
        <thead>
          <tr class="table-margin">
            <th class="t-head text-bold w-25 text-left"><span>Service Manager: {{ managerDetails.sales_manager_name ? managerDetails.sales_manager_name: '-' }}</span></th>
            <th class="t-head text-bold text-left"><span>Service Manager ID: {{ managerDetails.sales_manager_id ? managerDetails.sales_manager_id: '-' }}</span></th>
            <th class="t-head text-bold text-left"><span>From : {{ managerDetails.tour_start_date ? managerDetails.tour_start_date.split('-').reverse().join('/'):'-' }}</span></th>
            <th class="t-head text-bold text-left"><span>To : {{ managerDetails.tour_end_date ? managerDetails.tour_end_date.split('-').reverse().join('/'):'-' }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="t-head text-bold text-left"><span>Total Number Of Service Manager</span></td>
            <td class="t-head text-left"><span>{{ managerDetails.tour_plan_summary.total_sales_manager ? managerDetails.tour_plan_summary.total_sales_manager: '-' }}</span></td>
          </tr>
          <tr>
            <td class="t-head text-bold text-left"><span>Total Number Of Service Manager Planed</span></td>
            <td class="t-head text-left"><span>{{ managerDetails.tour_plan_summary.total_planned_sales_manager ? managerDetails.tour_plan_summary.total_planned_sales_manager: '-' }}</span></td>
          </tr>
          <tr>
            <td class="t-head text-bold text-left"><span>Service Manager Not Included In Current Tour Plan</span></td>
            <td class="t-head text-left"><span>{{ managerDetails.tour_plan_summary.total_unplanned_sales_manager ? managerDetails.tour_plan_summary.total_unplanned_sales_manager: '-' }}</span></td>
          </tr>
        </tbody>
      </table>
      <v-card-text v-if="user.roles.includes('area_service_manager')" style="background-color: #EAF4FF;">
        <v-row>
          <v-col class="d-flex flex-column text-left">
            <span>ASM</span>
            <span class="text-bold">{{ user.first_name }}</span>
          </v-col>
          <v-col class="d-flex flex-column  text-left">
            <span>ASM ID</span>
            <span class="text-bold">{{ user.id }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>From</span>
            <span class="text-bold">{{ managerDetails.tour_start_date ? managerDetails.tour_start_date.split('-').reverse().join('/') : '-' }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>To</span>
            <span class="text-bold">{{ managerDetails.tour_end_date ? managerDetails.tour_end_date.split('-').reverse().join('/') : '-'}}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column text-left">
            <span>Mapped Customer</span>
            <span class="text-bold">{{ managerDetails.tour_plan_summary.total_sales_manager }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>Customer Planned</span>
            <span class="text-bold">{{ managerDetails.tour_plan_summary.total_planned_sales_manager }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>Customer Not Planned</span>
            <span class="text-bold">{{ managerDetails.tour_plan_summary.total_unplanned_sales_manager }}</span>
          </v-col>
          <v-col>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card-text>
  <!-- </v-card> -->
  <!-- <v-card class="v-card-100"> -->
    <v-layout column class="select-card">
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table
          :dense="true"
          density="compact"
          :search="search"
          v-model="selected"
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="60%" 
          :loading="loading"
          return-object
          loading-text="Loading Data... Please wait"
          class="elevation-1" >
          <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
              <v-span v-if="header.value != 'visit_date'">
                {{ item[`${header.value}`] ? item[`${header.value}`] : '-' }}
              </v-span>
              <v-span v-else-if="header.value == 'visit_date'">
                {{ item.visit_date && item.visit_date != "null"  ? item.visit_date.split('-').reverse().join('/') : '-'}}
              </v-span>
              <v-span v-else>
                {{ item[`${header.value}`] ? item[`${header.value}`] : '-' }}
              </v-span>
            </template>
            <!-- <template v-slot:item.visit_date = "{item}">
              {{ item.visit_date && item.visit_date != "null"  ? item.visit_date.split('-').reverse().join('/') : '-'}}
            </template> -->
            <template v-slot:item.customer_name="{ item }" v-if="user.roles.includes('area_service_manager')">
            {{ item.customer_name.cutomer_name }}
          </template>
          <template v-slot:item.date="{ item }" v-if="user.roles.includes('area_service_manager')">
            {{ item.date.split('-').reverse().join('/') }}
          </template>
        </v-data-table> 
      </v-col>
    </v-layout>
    <v-card-actions class="float-right">
      <v-btn class="mb-8 text-none" color="primary" variant="outlined" @click="editItems">Edit</v-btn>
      <v-btn class="mb-8 text-none" variant="flat" color="primary" @click="confirmTourplan">Continue</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue'
  export default {
    components: {
      HeaderComponent,
    },
    data() {
      return {
        headerText: "Tour Plan",
        alert: false,
        alert_type: "success",
        alert_message: '',
        selected: [],
        table_data : [],
        managerDetails: [],
        search: '',
        loading: false,
        search_tag: '',
        sales_info : '',
        messagePopup : false,
        message : '',
        tour_id : '',
        headers: [
          { text: "Date", value: "visit_date" },
          { text: "Service Manager 1", value: "manager_customer_name" },
          { text: "Service Manager 2", value: "assigned_partner" },
          { text: "Service Manager 3", value: "assigned_partner" },
        ],
      }
    },
    created(){
      this.user = this.$store.state.currentUser
      this.managerDetails = this.$store.state.params
      this.sales_info = this.$store.state.sales_info
      this.selected_method = this.$store.state.selected_method
      this.tour_id = this.$store.state.tour_id
      this.updateHeaderTableData();
    },
    methods : {
      getRouterLink(){
        this.$store.commit("setLotIds", {
            action:'Pending Approval',
        })
        return { name: "tourVisit" };
      },
      getRouterLinkText(){
        return 'Pending Approval'
      },
      componentsName(){
        return this.tour_id
      },
      editItems(){
        this.$store.commit("setFtaConfirmationInfo", {
          params : this.managerDetails,
          sales_info : this.sales_info,
          selected_method : this.selected_method,
          direction : true,
          tour_id : this.tour_id
        });
        this.$router.push({ name: "editTourPlan" });
      },
      confirmTourplan(){
        // let managerDetailsCopy = { ...this.managerDetails };
        // if (managerDetailsCopy && managerDetailsCopy.tour_plan_summary && managerDetailsCopy.tour_plan_summary.visit_summary) {
        //   managerDetailsCopy.tour_plan_summary.visit_summary.forEach(summary => {
        //     delete summary.sales_manager_name;
        //   });
        // }
        var params;
        if(this.user.roles.includes('area_service_manager')){
          const visitSummary = []
          this.managerDetails.tour_plan_summary.visit_summary.forEach(item => {
            const address_hash = {}
            const customerId = typeof item.customer_name === 'object' ? item.customer_name.cutomer_id : item.customer_name;
            address_hash[customerId] = [item.address];
            // item.address.forEach(loc => {
            //   address_hash[item.customer_name.cutomer_id].push(loc.id)
            // })
            visitSummary.push(
              {
                "date": item.date,
                "customers": [customerId],
                "address_hash" : address_hash
              }
            )
          })
          params = {
            "id": this.managerDetails.id,
            "tour_start_date": this.managerDetails.tour_start_date,
            "tour_end_date": this.managerDetails.tour_end_date,
            "tour_method": this.managerDetails.tour_method,
            "sales_manager_name": this.user.first_name,
            "sales_manager_id": this.user.id,
            "tour_plan_summary": {
              "total_sales_manager": this.managerDetails.tour_plan_summary.total_sales_manager,
              "total_planned_sales_manager": this.managerDetails.tour_plan_summary.total_unplanned_sales_manager,         
              "total_unplanned_sales_manager": this.managerDetails.tour_plan_summary.total_unplanned_sales_manager,
              "visit_summary": visitSummary
            }
          };
        }else {
          params = this.managerDetails
        }
        this.$httpSecured
        .put(`/api/v1/warehouse/fta/tour_plan/tours/${this.managerDetails.id}`,params)
        .then(response => {
          this.messagePopup = true;
          this.message = response.data.message
        })
        .catch(error => {
          this.showAlert("error", error.response.data.message);
        });
      },
      redirectToIndex(){
        this.$store.commit("setLotIds", {
            action:'Pending Approval',
        })
        this.$router.push({ name: "tourVisit" });
      },
      updateHeaderTableData(){
        const listOfVisit = this.managerDetails.tour_plan_summary.visit_summary
        const groupedVisits = {};
        // this.sales_manager_mapping = {}
        var sales_manager_count = 0;
        
        listOfVisit.forEach(visit => {
          if(visit.date){
            if (!groupedVisits[visit.date]) {
              groupedVisits[visit.date] = [];
            }
            groupedVisits[visit.date].push({ 
              name: visit.manager_name, 
            });
            sales_manager_count = Math.max(sales_manager_count,groupedVisits[visit.date].length) 
          }
        });
        // var uniqueSalesManagers = Array.from(new Set(listOfVisit.map(visit => visit.sales_manager_name)))
        // uniqueSalesManagers = uniqueSalesManagers.filter((value) => value !== null);
        const headers = [{ text: 'Date', value: 'visit_date' }];
        for(var ind = 0;ind<sales_manager_count;ind++)
          headers.push({ text: `Service Manager ${ind + 1}`, value: `sales_manager_name_${ind + 1}` });
        // uniqueSalesManagers.forEach((manager, index) => {
        //   headers.push({ text: `Service Manager ${index + 1}`, value: `sales_manager_name_${index + 1}` });
        //   this.sales_manager_mapping[manager] = `sales_manager_name_${index + 1}`
        // });
        const tableData = [];
        Object.keys(groupedVisits).forEach(date => {
          const rowData = { visit_date: date };
          groupedVisits[date].forEach((manager, index) => {
            if(manager){
              rowData[`sales_manager_name_${index + 1}`] = manager.name;
              // rowData[this.sales_manager_mapping[manager.name]] = manager.name;
              // this.check_visited_sales_manager[`${date}_${this.sales_manager_mapping[manager.name]}`] = (manager && manager.role && manager.role == 1 ) ? manager.is_visited ? 'Visited' : 'Not Visited' : 'NA'
            }
          });
          tableData.push(rowData);
        });
        this.headers = headers;
        tableData.sort((a, b) => {
          let dateA = new Date(a.visit_date);
          let dateB = new Date(b.visit_date);
          return dateA - dateB;
        });
        this.table_data = tableData;
        if(this.user.roles.includes('area_service_manager')){
          this.table_data =this.managerDetails.tour_plan_summary.visit_summary
          this.headers = [
            { title: 'Date', key: 'date' },
            { title: 'Type of Vendor', key: 'vendor' },
            { title: 'Vendor Name', key: 'customer_name'},
            { title: 'Location', key: 'address_name'}
          ]
          // this.table_data = listOfVisit
        }
        // const groupedVisits = {};
        // listOfVisit.forEach(visit => {
        //   if (!groupedVisits[visit.date]) {
        //     groupedVisits[visit.date] = [];
        //   }
        //   groupedVisits[visit.date].push(visit.sales_managers);
        // });
        // const uniqueSalesManagers = Array.from(new Set(listOfVisit.map(visit => visit.sales_managers))).slice(0, 3);
        // const headers = [{ text: 'Date', value: 'visit_date' }];
        // uniqueSalesManagers.forEach((manager, index) => {
        //   headers.push({ text: `Service Manager ${index + 1}`, value: `sales_manager_${index + 1}` });
        // });
        // const tableData = [];
        // Object.keys(groupedVisits).forEach(date => {
        //   const rowData = { visit_date: date };
        //   uniqueSalesManagers.forEach((manager, index) => {
        //     const salesManager = groupedVisits[date][index];
        //     if(this.managerDetails.tour_method == 'date_wise'){
        //       rowData[`sales_manager_${index + 1}`] = salesManager ? salesManager[0].sales_manager : '-';
        //     }
        //     else 
        //       rowData[`sales_manager_${index + 1}`] = salesManager ? salesManager : '-';
        //   });
        //   tableData.push(rowData);
        // });
        // this.headers = headers;
        // this.table_data = tableData;
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTOp();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {this.alert = false;}, 3000);
      },
      scrollToTOp(){
          window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
    }
  }
</script>
<style scoped>
.table-margin {
    border-bottom: 1px solid #ccc;
  }
  .t-head{
    padding: 12px 0px 12px 25px;
  }
  .text-bold {
    font-size: 14;
    font-weight: 600;
    line-height: 16.94px;
  }
  .select-card {
    border-top: 21px solid #E5E5E5
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 430px) !important;
  }
</style>